/*
 *
 * Assessment constants
 *
 */

export const PROCESSING = 'app/Assessment/PROCESSING';
export const ANSWERS_PROCESSING = 'app/Assessment/ANSWERS_PROCESSING';
export const GET_ASSESSMENT = 'app/Assessment/GET_ASSESSMENT';
export const GET_ASSESSMENT_SUCCESS = 'app/Assessment/GET_ASSESSMENT_SUCCESS';
export const GET_ASSESSMENT_FAIL = 'app/Assessment/GET_ASSESSMENT_FAIL';
export const GET_ANSWERS = 'app/Assessment/GET_ANSWERS';
export const GET_ANSWERS_SUCCESS = 'app/Assessment/GET_ANSWERS_SUCCESS';
export const GET_ANSWERS_FAIL = 'app/Assessment/GET_ANSWERS_FAIL';
export const PUT_ASSESSMENT = 'app/Assessment/PUT_ASSESSMENT';
export const PUT_ASSESSMENT_RESULT = 'app/Assessment/PUT_ASSESSMENT_RESULT';
export const GET_ASSESSMENT_RESULT = 'app/Assessment/GET_ASSESSMENT_RESULT';
export const GET_ASSESSMENT_RESULT_SUCCESS =
  'app/Assessment/GET_ASSESSMENT_RESULT_SUCCESS';
export const GET_ASSESSMENT_RESULT_FAIL =
  'app/Assessment/GET_ASSESSMENT_RESULT_FAIL';
export const GET_ASSESSMENT_REPORT = 'app/Assessment/GET_ASSESSMENT_REPORT';
export const GET_ASSESSMENT_REPORT_RESULT =
  'app/Assessment/GET_ASSESSMENT_REPORT_RESULT';

export const ASSESSMENT_COLORS = {
  aqua: { main: '#004F45' },
  blue: { main: '#005573' },
  gold: { main: '#603E11' },
  grey: { main: '#414141' },
};

export const contextRegex = /context\[[^\s\[\]]+\]/g;
export const anyRegex = /any\(([^)]+), ([^)]+), ([0-9]+)\)/g;
export const containsRegex = /contains\(\[([^\s,]+)\],[\s]*\[([^\s]+[,( )*]*)+\]\)/g;
export const variableRegex = /\[[^+\s,]+\]/g;
export const numberRegex = /\d+/g;
export const visibleIfRegex = /\{[a-zA-Z0-9]+\}/g;
export const visibleIfContainsRegex = /{([0-9a-zA-Z]+)} contains (["[0-9a-zA-Z]+"])/g;
